import React from "react";

import { useTheme } from "@mui/material";

import { tss } from 'tss-react';
import styles from "./styles";

export default function LogoHeader() {
  const theme = useTheme();
  const { classes } = tss.create(styles)();

  return (
    <div className={classes.root}>
      <a href="/" className={classes.logo}>
        <theme.images.Logo/>
      </a>
      { theme.configuration.gloryToUkraine && (
        <a href="https://websa.advancedhosting.com/StandWithUkraine.html" className={classes.gloryToUkraine}>
          <theme.images.GloryToUkraine/>
        </a>
      )}
    </div>
  )
}
